export default "__VITE_ASSET__433ef8b4__"